export default __webpack_public_path__ + "static/media/snack_bar_white.145fd322.png";